var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-img',{attrs:{"src":_vm.dataUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }